import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
    title: {
        fontSize: "1.4rem"
    },
    paper: {
        margin: "10px"
    },
    progressBar: {
        "& .MuiLinearProgress-barColorPrimary": {
            backgroundColor: "#3474b4"
        }
    },
    imageViewerMessage: {
        textAlign: "center",
        fontSize: "0.875rem",
        paddingTop: 40,
        paddingBottom: 50
    },
    emptyImageViewerMessage: {
        color: "red"
    },
    imgViewerContainer: {
        paddingBottom: 40
    },
    flow: {
        flexGrow: 1
    }
});
